import gql from 'graphql-tag'

const EnumQuery = gql`
query EnumQuery{
    agreementStates:__type(name: "CarsAgreementStageChoices") {
        states: enumValues {
            name
            description
        }
     }
     carReturnStates:__type(name: "CarsCarReturnStageChoices") {
        states: enumValues {
            name
            description
        }
     }
     reservationPickupStates:__type(name: "CarsReservationPickupTypeChoices") {
        states: enumValues {
            name
            description
        }
     }
     chargeTypes:__type(name: "TransactionChargeType") {
        states: enumValues {
            name
            description
        }
     }
     paymentPlanReasons:__type(name: "CarsPaymentPlanReasonChoices") {
      states: enumValues {
          name
          description
      }
     }

     accountTypes:__type(name: "TransactionAccount") {
        states: enumValues {
            name
            description
        }
     }
}
`

const UserQuery = gql`query UserQuery{
    currentUser{
      id
      pk
      unreadNotificationsCount
      assignedUnreadConversationsCount
      username
      firstName
      lastName
      email
      isSuperuser
      isManager
      isBilling
      isFrontOffice
      isTopManagement
      authLevel
      isBroker
      groupNames
      member {
        id
        globalView
        preferredTimezone
        preferredTimeFormat
        preferredDateFormat
        preferredMenuItems
        showPinnedMenuItems
        displayFullUsername
        taskManagementViewType
        kanbanColumnConfig
        boardViewTypeConfig
        tenant { id name }
        defaultBranch{ id name }
        branches {
          edges { node { id name } }
        }
        selectedBranches{
          edges { node { id name } }
        }
      }
    }
}`

const GetConfigurationSettings = gql`
query GetConfigurationSettings($name:String!, $branchId:ID, $driverId:ID){
  getConfigurationSettings(name:$name, branchId:$branchId, driverId:$driverId)
}
`
const GlobalSettingsQuery = gql`
query GlobalSettingsQuery{
    globalSettings {
        edges {
          node {
            settingsName
            settingsValue
          }
        }
    }
}
`
const RepsQuery = gql`
    query AllRepsQuery($groups:[String], $permissions:[String], $orderBy:[String], $searchTerm:String, $first:Int, $last:Int){
      allReps(isStaff:true, isActive:true, groups: $groups, permissions: $permissions, orderBy:$orderBy, searchTerm:$searchTerm, first:$first, last:$last){
        edges{
          node{
            id
            name
            username
            firstName
            lastName
            email
            isBilling
            isFrontOffice
            assignedCount
          }
        }
      }
    }
`

const AuditLogsQuery = gql`
query AuditLogsQuery{
    allAuditLogs(auditStage:_1){
      edges{
        node{
          id
        }
      }
    }
  }
`
const CarStages = gql`query CarStages{
  carStages: __type(name: "CarsCarStageChoices") {
      states: enumValues {
          name
          description
      }
  }
}`
const CarIssueStatuses = gql`query CarIssueStatuses{
  carIssueStatuses:__type(name:"CarsCarIssuesStatusChoices"){
    states: enumValues{
      name
      description
    }
  }
}`
const CarIssueSeverities = gql`query CarIssueSeverities{
  carIssueSeverities:__type(name:"CarsCarIssuesSeverityChoices"){
    states: enumValues{
      name
      description
    }
  }
}`
const JobStatuses = gql`query JobStatuses{
  jobStatuses:__type(name:"MaintenanceJobStatusChoices"){
    states: enumValues{
      name
      description
    }
  }
}`
const CarIssueCategories = gql`query CarIssueCategories{
  carIssueCategories: __type(name: "CarsCarIssueCategoryTypeChoices") {
      states: enumValues {
          name
          description
      }
  }
}`
const TagsQuery = gql`query TagsQuery{
  tags: allTags{
    edges {
      node {
        id
        name
        color
      }
    }
  }
  driverTags: allTags(contentType: 13){
    edges {
      node {
        id
        name
        color
      }
    }
  }
  carTags: allTags(contentType: 11){
    edges {
      node {
        id
        name
        color
      }
    }
  }  
}`

const assignDriverToRepMutation = gql`
    mutation CreateNewAssignment($repID:ID!, $drivers:ID!){
      createAssignment(input:{repId:$repID, drivers:[$drivers]}){
        assignment{
            id
        }
      }
  }`

const HasPermissionsQuery = gql`query hasPermissions($userPermissions: [String]!){
    hasPermissions(userPermissions:$userPermissions)
}`

const AllBranchSettings = gql`
query AllBranchSettings($branchId: ID!, $settingNames: [String!]) {
  allBranchSettings(branchId: $branchId, key_Name_In: $settingNames) {
    edges {
      node {
        id
        key {
          id
          name
          description
          isRequired
        }
        value
      }
    }
  }
}
`
export {
    EnumQuery,
    UserQuery,
    GlobalSettingsQuery,
    GetConfigurationSettings,
    AuditLogsQuery,
    RepsQuery,
    TagsQuery,
    assignDriverToRepMutation,
    CarStages,
    CarIssueStatuses,
    CarIssueSeverities,
    JobStatuses,
    HasPermissionsQuery,
    CarIssueCategories,
    AllBranchSettings
}
